export { default } from './auto-credit-header';
